import { Avatar, Box } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  auth,
  signInWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  sendEmailVerification,
  PhoneAuthProvider,
  RecaptchaVerifier,
  getMultiFactorResolver,
  PhoneMultiFactorGenerator,
} from '../../../firebase/index';
import { useMainFrameState } from '../MainFrame';
import { mainLogoDimen, toPixel } from '../styles/dimensions';
import CredentialsManagementIcon from 'assets/credentialsManagementIcon';

//changes from shylu//
function CurrentUser() {
  const [displayName, setDisplayName] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, user => {
      console.log(`Auth state changed`, user, auth);
      // console.log(user.displayName,'user')
      if (user) {
        setDisplayName(user.displayName);
      } else {
        setDisplayName(null);
      }
    });

    console.log(`APPJS AGAIN`, unsubscribe);

    return () => {
      unsubscribe();
    };
  }, []);

  return (
    <>
      <Box sx={{ fontSize: 14.5 }}>
        {displayName?.substring(0, displayName?.lastIndexOf(' '))}
      </Box>
    </>
  );
}

const AvatarDesign = () => {
  const { mainDrawerOpen } = useMainFrameState();

  return (
    <Box
      sx={{
        padding: 0,
      }}
    >
      <Avatar
        sx={{
          width: toPixel(mainLogoDimen.closed.width),
          height: toPixel(mainLogoDimen.closed.height),
        }}
      >
        {auth?.currentUser?.displayName.slice(0, 1)}
      </Avatar>
    </Box>
  );
};

export const mainDrawerJson = [
  {
    icon: 'space_dashboard',
    title: 'DASHBOARD',
    name: 'dashboard',
    link: 'home/dashboard',
    submenu: [],
    isActive: false,
  },
  {
    // icon: 'storage',
    // icon: CredentialsManagementIcon,
    icon: 'manage_accounts',
    title: 'ALERTS',
    name: 'credentialsManagement',
    link: 'credentials/credentialsalerts',
    submenu: [],
    isActive: false,
    adminModule: true
  },
  {
    // icon: 'storage',
    // icon: CredentialsManagementIcon,
    icon: 'manage_accounts',
    title: 'CREDENTIALS_STATUS',
    name: 'usercredentialsManagement',
    link: 'user/credentialsstatus',
    submenu: [],
    isActive: false,
    userModule:true,
  },
  {
    icon: 'groups',
    title: 'STAFF',
    name: 'staffManagement',
    link: 'staff/manage',
    submenu: [],
    isActive: false,
    adminModule: true
  },
  {
    icon: 'settings',
    title: 'SETTINGS',
    name: 'config',
    link: 'config/departmentsandroles',
    submenu: [],
    isActive: false,
    adminModule: true
  },
  // {
  //   icon: 'upload_file',
  //   title: 'DOCUMENT_UPLOAD',
  //   name: 'documentView',
  //   link: 'documents/upload',
  //   submenu: [],
  //   isActive: false,
  //   adminModule: true
  // },
  {
    icon: 'info',
    title: 'ABOUT',
    name: 'About',
    link: 'about/us',
    submenu: [],
    isActive: false,
  },
  {
    icon: <AvatarDesign />,
    // title: <CurrentUser />,
    title: 'MY_PROFILE',
    name: auth?.currentUser?.displayName,
    name: 'My Profile',
    link: 'myprofile/profile',
    isAvatar: true,
    submenu: [],
    isActive: false,
  },
  {
    icon: 'theme',
    title: 'THEME',
    name: 'Theme',
    link: 'theme',
    submenu: [],
    isActive: false,
  },
  {
    icon: 'translate',
    title: 'CHANGE_LANGUAGE',
    name: 'Change Language',
    link: 'translate',
    submenu: [{ label: 'English', value: 'en' }, { label: 'Español (Spanish)', value: 'es' }],
    isActive: false,
  },
  {
    icon: 'logout',
    title: 'LOGOUT',
    name: 'Logout',
    link: 'logout',
    submenu: [],
    isActive: false,
  },
];
